import { render } from "./StudentGrantFormV2.vue?vue&type=template&id=4d9fbc72&scoped=true"
import script from "./StudentGrantFormV2.vue?vue&type=script&lang=js"
export * from "./StudentGrantFormV2.vue?vue&type=script&lang=js"

import "./StudentGrantFormV2.vue?vue&type=style&index=0&id=4d9fbc72&scoped=true&lang=scss"
import "./StudentGrantFormV2.vue?vue&type=style&index=1&id=4d9fbc72&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9fbc72"]])

export default __exports__